import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { useEffect } from "react";
export const EmbeddedVideo = ({ playback_url, muted, loop, autoPlay, playsInline }) => {
    const splicedUrl = playback_url.split("/").flatMap(i => i.split("."));
    const videoId = `video-${splicedUrl[splicedUrl.length - 2]}`;
    useEffect(() => {
        const video = document.querySelector(`#${videoId}`);
        const src = `${playback_url}?fm=hls`;
        if (video && video.canPlayType("application/vnd.apple.mpegurl")) {
            video.src = src;
        }
        else {
            //lazy load library to avoid performance impact as hls library is big
            import("hls.js")
                .then(it => it.default)
                .then(Hls => {
                if (Hls.isSupported()) {
                    const hls = new Hls();
                    hls.loadSource(src);
                    hls.attachMedia(video);
                }
                else {
                    console.error("This is a legacy browser that doesn't support Media Source Extensions");
                }
            });
        }
    }, []);
    return (_jsx("video", { id: videoId, sx: {
            width: "100%"
        }, crossOrigin: "anonymous", muted: muted, loop: loop, autoPlay: autoPlay, playsInline: playsInline }));
};
export default EmbeddedVideo;
//# sourceMappingURL=EmbeddedVideo.js.map